<template>
  <div class="donut-score">
    <svg
      :width="width"
      :height="height"
      :viewBox="`0 0 ${width} ${height}`"
    >
      <circle
        class="donut-bg"
        :cx="center"
        :cy="center"
        :r="radius"
        fill="none"
        stroke="#d7dbde"
        :stroke-width="stroke"
      />
      <circle
        class="donut-value"
        :stroke="color"
        :cx="center"
        :cy="center"
        :r="radius"
        fill="none"
        :stroke-width="stroke"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="offset"
        stroke-linecap="round"
        :transform="`rotate(-90 ${center} ${center})`"
      />
      <template v-if="score">
        <text
          :x="center"
          :y="center - height * 0.08"
          text-anchor="middle"
          class="score-text"
          :font-size="fontSizeScore"
        >{{ percent }}%</text>
        <text
          :x="center"
          :y="center + height * 0.14"
          text-anchor="middle"
          class="rating-text"
          :font-size="fontSizeRating"
        >{{ rating }}</text>
      </template>
      <text
        v-else
        :x="center"
        :y="center"
        text-anchor="middle"
        class="score-text"
        :font-size="fontSizeScore"
      >N/A</text>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      default: 80,
    },
    height: {
      type: Number,
      default: 80,
    },
    stroke: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    center() {
      return this.width / 2;
    },
    radius() {
      // Padding for stroke
      return (Math.min(this.width, this.height) - this.stroke) / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    percent() {
      return Math.max(0, Math.min(100, Math.round(this.score)));
    },
    offset() {
      return this.circumference * (1 - this.percent / 100);
    },
    rating() {
      if (this.score >= 83) return 'Excellent';
      if (this.score >= 50) return 'Average';
      return 'Poor';
    },
    color() {
      if (this.score >= 83) return '#28a745';
      if (this.score >= 50) return '#ffc107';
      return '#dc3545';
    },
    fontSizeScore() {
      return `${this.height * 0.18}px`;
    },
    fontSizeRating() {
      return `${this.height * 0.12}px`;
    },
  },
};
</script>

<style scoped>
.donut-score {
  display: flex;
  align-items: center;
  justify-content: center;
}
.donut-bg {
  opacity: 0.3;
}
.donut-value {
  transition: stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.score-text {
  font-weight: bold;
  fill: #222;
  dominant-baseline: middle;
}
.rating-text {
  fill: #666;
  dominant-baseline: middle;
}
</style>